import{Window as t}from"./server-safe-globals.js";function e(i,o){t.customElements.get(i)||(t.customElements.define(i,o),t[o.name]=o)}export{e as defineCustomElement};
//# sourceMappingURL=defineCustomElement.js.map
